export default "__VITE_ASSET__7jow_nx$__"